import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../utils/api/axiosInstance";

const RegionContext = createContext({
  region: "US",
});

export const RegionProvider = ({ children }) => {
  const [region, setRegion] = useState("US");

  useEffect(() => {
    let isMounted = true;
    api
      .get("/region")
      .then((res) => {
        if (isMounted && res.data?.region) {
          setRegion(res.data.region);
        }
      })
      .catch(() => {
        // Keep the "US" default on failure
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(() => ({ region }), [region]);

  return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>;
};

export const useRegion = () => useContext(RegionContext);
